import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  account: {
    display: 'flex',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white,
  },
  accountContent: {
    flex: '1 1 auto',
    marginLeft: theme.spacing(2),
  },
  accountName: {
    fontWeight: 500,
  },
  accountAvatar: {
    width: 48,
    height: 48,
  },
}));

export default useStyles;
